export const TABLE_HEADERS = {
  REF_NUMBER: "Reference No",
  REQUEST_TYPE: "Request Type",
  USER: "User",
  SYSTEM_CATEGORY: "System Category",
  NAME: "Name",
  ENVIRONMENT: "Environment",
  ROLE: "Role",
  EFFECTIVE_DATE: "Effective Date",
  STATUS: "Status",
  DEVICE_TYPE: "Device Type",
  REQUESTED_BY: "Requested By",
  DATE_REQUESTED: "Date Requested",
  USER_EMAIL: "User Email",
  DATE_ADDED: "Date Added",
  RF_NO: "RF No",
  BUSSINES_UNIT: "Bussines Unit",
  REQUESTOR: "Requestor",
};

export const TOOLTIPS = {
  NAME: "System, Device, Server, Database, Network",
};

export const M_TABLE_HEADERS_ENVIRONMENT = {
  NAME: "Environment Name",
  IS_ACTIVE: "Is Active",
  ACTION: "Action",
};

export const M_TABLE_HEADERS_SYSTEMTYPE = {
  NAME: "Business Unit Name",
  IS_ACTIVE: "Is Active",
  ACTION: "Action",
};

export const M_TABLE_HEADERS_CATEGORIES = {
  NAME: "System Category Name",
  IS_ACTIVE: "Is Active",
  IS_MANUAL: "Is Manual",
  BUSINESS_UNIT: "Business Unit",
  ACTION: "Action",
};

export const M_TABLE_HEADERS_EMPLOYEES = {
  USERID: "Employee ID",
  EMAIL: "Email",
  MANAGER_EMAIL: "Manager Email",
  VP_EMAIL: "VP Email",
  SVP_EMAIL: "SVP Email",
  LOCATION: "Location",
  SECOND_MANAGER_EMAIL: "Second Manager Email",
};

export const M_TABLE_HEADERS_EMPLOYEEDELEGATES = {
  NAME: "Name",
  EMAIL: "Email",
};

export const M_TABLE_HEADERS_GSAP = {
  SECURITY_ROLE: "Security Role",
  ACCESS_TYPE: "Access Type",
  IS_ACTIVE: "Is Active",
};

export const M_TABLE_HEADERS_SALESFORCE_PROFILE = {
  PROFILE_NAME: "Profile Name",
  USER_TYPE: "User Type",
  REGION: "Region",
  IS_ACTIVE: "Is Active",
};

export const M_TABLE_HEADERS_SALESFORCE_ROLE = {
  ROLE_NAME: "Role Name",
  IS_ACTIVE: "Is Active",
  REGION: "Region",
};

export const M_TABLE_HEADERS_SYSTEM_APPNAME = {
  SYSTEM_NAME: "System Name",
  CATEGORY: "Category",
  BUSINESS_UNIT: "Business Unit",
  SYSTEM_DESC: "System Description",
  APPROVER: "Approver",
  IS_ACTIVE: "Is Active",
  IS_REVOKE_NEEDED: "Is Revoke Needed Form",
  IS_REQUIRE_ATTESTATION: "Is Require Attestation",
  IS_SINGLE_REQUEST: "Is Single Request",
  IS_MULTIPLE_FORM: "Is Multiple Form",
  UAM_NOTE: "UAM Note",
  META_DATA: "Meta Data",
};
export const M_TABLE_HEADERS_INFRASTRUCTURE = {
  TYPE_NAME: "Type Name",
  WITH_APP_NAME: "With App Name",
  APPROVER2: "Approver 2",
  APPROVER3: "Approver 3",
  APPROVER4: "Approver 4",
  APPROVER_DISTRO_2: "Approver Distro 2",
  APPROVER_DISTRO_3: "Approver Distro 3",
  APPROVER_DISTRO_4: "Approver Distro 4",
  BUSINESS_UNIT: "Business Unit",
  META_DATA: "Meta Data",
  UAM_NOTE: "UAM Note",
  ACCESS_DETAIL_NOTE: "Access Detail Note",
  IS_ACTIVE: "Is Active",
};

export const M_TABLE_HEADERS_ROLE = {
  ROLE_NAME: "Role Name",
  SYSTEM_APP_NAME: "System App Name",
  SYSTEM_TYPE: "System Type",
  SYSTEM_CATEGORY: "System Category",
  IS_ACTIVE: "Is Active",
};

export const M_TABLE_HEADERS_ACCESS_ADMINS = {
  GROUP_NAME: "Group Name",
  MEMBERS: "Members",
};

export const M_TABLE_HEADERS_INFRA_APP = {
  APP_NAME: "App Name",
  APPROVER: "Approver",
  APPROVER_DISTRO: "Approver Distro",
  INFRASTRUCTURE: "Infrastructure",
  IS_ACTIVE: "Is Active",
};

export const M_TABLE_HEADERS_APPROVERDISTRO = {
  NAME: "Distro Name",
  IS_ACTIVE: "Is Active",
  ACTION: "Action",
  DISTRO_MEMBERS: "Distro Members",
};

export const M_TABLE_HEADERS_FEEDBACKS = {
  DISTRO_MEMBERS: "Distro Members",
  FEEDBACK_ID: "Feedback ID",
  FEEDBACK_TYPE: "Feedback Type",
  DETAILS: "Details",
  STATUS: "Status",
  DATETIME_ADDED: "Date Added",
  SENT_BY: "Sent By",
  SUBJECT: "Subject",
  BUSINESS_UNIT: "Business Unit",
};

export const M_TABLE_HEADERS_VIPS = {
  VIP_EMAIL: "VIP Approver",
  APPROVER_EMAIL: "Authorized Approver",
  IS_ACTIVE: "Is Active",
};

export const M_TABLE_HEADERS_ANNOUNCEMENTS = {
  TITLE: "Title",
  DATE_POSTED: "Date Posted",
  POSTED_BY: "Posted By",
  IS_ACTIVE: "Is Active",
  MESSAGE: "Message",
};

export const M_TABLE_HEADERS_LANDING_ZONES = {
  NAME: "Landing Zone Name",
  IS_ACTIVE: "Is Active",
  APPROVER2: "Approver 2",
  APPROVER3: "Approver 3",
  APPROVER4: "Approver 4",
  APPROVER_DISTRO_2: "Approver Distro 2",
  APPROVER_DISTRO_3: "Approver Distro 3",
  APPROVER_DISTRO_4: "Approver Distro 4",
};

export const M_TABLE_HEADERS_LANDING_ZONE_ROLES = {
  NAME: "Landing Zone Role Name",
  IS_ACTIVE: "Is Active",
};
